/*
 * @description: 得到边框组件配置
 * @Date: 2023-03-16 10:49:11
 */
export default function getComponentConfig(type, classNameType) {
    const className =
        'com.gccloud.dataroom.core.module.chart.components.ScreenBorderChart'
    switch (type) {
        case 'border1':
            return {
                name: '边框一',
                title: '边框一',
                icon: null,
                img: require('@/components/data-room-ui/packages/Borders/images/border-1.png'),
                component: null,
                className,
                w: 450,
                h: 320,
                x: 0,
                y: 0,
                type
            }
        case 'border2':
            return {
                name: '边框二',
                title: '边框二',
                icon: null,
                img: require('@/components/data-room-ui/packages/Borders/images/border-2.png'),
                component: null,
                className,
                w: 450,
                h: 320,
                x: 0,
                y: 0,
                type
            }
        case 'border3':
            return {
                name: '边框三',
                title: '边框三',
                icon: null,
                img: require('@/components/data-room-ui/packages/Borders/images/border-3.png'),
                component: null,
                className,
                w: 450,
                h: 320,
                x: 0,
                y: 0,
                type
            }
        case 'border4':
            return {
                name: '边框四',
                title: '边框四',
                icon: null,
                img: require('@/components/data-room-ui/packages/Borders/images/border-4.png'),
                component: null,
                className,
                w: 450,
                h: 320,
                x: 0,
                y: 0,
                type
            }
        case 'border5':
            return {
                name: '边框五',
                title: '边框五',
                icon: null,
                img: require('@/components/data-room-ui/packages/Borders/images/border-5.png'),
                component: null,
                className,
                w: 450,
                h: 320,
                x: 0,
                y: 0,
                type
            }
        case 'border6':
            return {
                name: '边框六',
                title: '边框六',
                icon: null,
                img: require('@/components/data-room-ui/packages/Borders/images/border-6.png'),
                component: null,
                className,
                w: 450,
                h: 320,
                x: 0,
                y: 0,
                type
            }
        case 'border7':
            return {
                name: '边框七',
                title: '边框七',
                icon: null,
                img: require('@/components/data-room-ui/packages/Borders/images/border-7.png'),
                component: null,
                className,
                w: 450,
                h: 320,
                x: 0,
                y: 0,
                type
            }
        case 'border8':
            return {
                name: '边框八',
                title: '边框八',
                icon: null,
                img: require('@/components/data-room-ui/packages/Borders/images/border-8.png'),
                component: null,
                className,
                w: 450,
                h: 320,
                x: 0,
                y: 0,
                type
            }
        case 'border9':
            return {
                name: '边框九',
                title: '边框九',
                icon: null,
                img: require('@/components/data-room-ui/packages/Borders/images/border-9.png'),
                component: null,
                className,
                w: 450,
                h: 320,
                x: 0,
                y: 0,
                type
            }
        case 'border10':
            return {
                name: '边框十',
                title: '边框十',
                icon: null,
                img: require('@/components/data-room-ui/packages/Borders/images/border-10.png'),
                component: null,
                className,
                w: 450,
                h: 320,
                x: 0,
                y: 0,
                type
            }
        case 'border11':
            return {
                name: '边框十一',
                title: '边框十一',
                icon: null,
                img: require('@/components/data-room-ui/packages/Borders/images/border-11.png'),
                component: null,
                className,
                w: 450,
                h: 320,
                x: 0,
                y: 0,
                type
            }
        case 'border12':
            return {
                name: '边框十二',
                title: '边框十二',
                icon: null,
                img: require('@/components/data-room-ui/packages/Borders/images/border-12.png'),
                component: null,
                className,
                w: 450,
                h: 320,
                x: 0,
                y: 0,
                type
            }
        case 'border13':
            return {
                name: '边框十三',
                title: '边框十三',
                icon: null,
                img: require('@/components/data-room-ui/packages/Borders/images/border-13.png'),
                component: null,
                className,
                w: 450,
                h: 320,
                x: 0,
                y: 0,
                type
            }
        case 'border14':
            return {
                name: '边框十四',
                title: '边框十四',
                icon: null,
                img: require('@/components/data-room-ui/packages/Borders/images/border-14.png'),
                component: null,
                className,
                w: 450,
                h: 320,
                x: 0,
                y: 0,
                type
            }
        case 'border15':
            return {
                name: '边框十五',
                title: '边框十五',
                icon: null,
                img: require('@/components/data-room-ui/packages/Borders/images/border-15.png'),
                component: null,
                className,
                w: 450,
                h: 450,
                x: 0,
                y: 0,
                type
            }

        default:
            return {}
    }
}
